/**
 * 자금계획 상태(라벨·색상) — 프론트 단일 진실 원천(SSOT).
 *
 * [기존 문제] 같은 상태 메타가 CashFlowTab / ExpensePlanReportTab / FinanceEntryModal /
 * UpcomingPaymentsBoard 4곳에 각각 복제돼 있었다(백엔드 enum 까지 5곳). 실제로 '긴급(URGENT)'
 * 상태를 추가할 때 4곳을 전부 손봐야 했고, 한 곳이라도 빠지면 그 화면에서만 라벨이 '예정'으로
 * 잘못 표시되는 드리프트가 발생한다. 상태 추가/색상 변경은 이제 이 파일만 고치면 된다.
 *
 * 백엔드 enum: gayasoft.co.kr.finance.enums.cashflow.FinanceCashPlanStatus
 */

/** 상태별 표시 메타. 긴급은 홀딩(연한 빨강)과 구분되도록 '꽉 찬 빨강 + 흰 글씨'로 가장 강하게. */
export const CASH_PLAN_STATUS = {
    SCHEDULED: { label: "예정",     color: "#2563eb", bg: "#eff6ff" },
    URGENT:    { label: "긴급",     color: "#ffffff", bg: "#dc2626" },
    PRIORITY:  { label: "우선지급", color: "#d97706", bg: "#fffbeb" },
    CONFIRMED: { label: "지급확정", color: "#7c3aed", bg: "#f5f3ff" },
    HOLD:      { label: "홀딩",     color: "#dc2626", bg: "#fef2f2" },
    COMPLETED: { label: "완료",     color: "#16a34a", bg: "#f0fdf4" },
};

/** 화면 표시 순서 (필터 칩·선택 목록 공통) */
export const STATUS_ORDER = ["SCHEDULED", "URGENT", "PRIORITY", "CONFIRMED", "HOLD", "COMPLETED"];

/** 기본으로 켜지는 상태 — "곧 나갈 돈"(예정·긴급·우선지급) */
export const DEFAULT_STATUSES = ["SCHEDULED", "URGENT", "PRIORITY"];

/** 예정 등록 폼에서 고를 수 있는 상태 (확정/완료는 별도 흐름) */
export const SCHEDULED_STATUS_VALUES = ["SCHEDULED", "URGENT", "PRIORITY", "HOLD"];

/**
 * 입금(수입)은 지급 순위 개념이 없다 — 예정/완료만 사용.
 * (지출 전용 상태를 수입에 걸면 현금흐름표에서 되돌릴 수 없는 상태가 만들어진다.)
 */
export const INCOME_STATUS_VALUES = ["SCHEDULED", "COMPLETED"];

/** 상태 코드 → 메타 (알 수 없는 값은 '예정'으로 폴백) */
export const statusInfo = (s) => CASH_PLAN_STATUS[s] || CASH_PLAN_STATUS.SCHEDULED;

/** { value, label, color, bg } 형태의 선택 옵션 목록 */
export const statusOptions = (values = STATUS_ORDER) =>
    values.map((v) => ({ value: v, ...CASH_PLAN_STATUS[v] }));
